import React from 'react';
import PropTypes from 'prop-types';
import InfoboxColumn from './column/component';
import clsx from 'clsx';
Infobox.propTypes = {
    columns: PropTypes.array,
    className: PropTypes.string,
    icon: PropTypes.string,
    includeGrid: PropTypes.bool,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    children: PropTypes.any,
    headerRender: PropTypes.func
};
export default function Infobox(_a) {
    var _b = _a.columns, columns = _b === void 0 ? [] : _b, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.icon, icon = _d === void 0 ? '' : _d, _e = _a.includeGrid, includeGrid = _e === void 0 ? true : _e, _f = _a.title, title = _f === void 0 ? '' : _f, _g = _a.subtitle, subtitle = _g === void 0 ? '' : _g, _h = _a.children, children = _h === void 0 ? null : _h, _j = _a.headerRender, headerRender = _j === void 0 ? null : _j;
    var gridColLength = columns.length > 0
        ? Math.max(1, Math.floor(12 / columns.length))
        : 12;
    var colClass = clsx('infobox__column', includeGrid && "f-grid-col-".concat(gridColLength));
    function renderHeader() {
        if (!title && !subtitle)
            return null;
        return (React.createElement("div", { className: clsx('infobox__header', icon && 'infobox__header--with-icon') },
            icon ? React.createElement("div", { className: "infobox__icon icon--img icon--".concat(icon) }) : '',
            React.createElement("div", { className: "infobox__titles" },
                React.createElement("div", { className: "infobox__heading" }, title),
                React.createElement("div", { className: "infobox__subheading" }, subtitle)),
            headerRender ? React.createElement("div", { className: "infobox__dynamicheader" }, headerRender()) : null));
    }
    return (React.createElement("div", { className: "infobox" },
        React.createElement("div", { className: clsx('infobox__wrapper', className) },
            renderHeader(),
            columns.length > 0 ? (React.createElement("div", { className: "f-grid" }, columns.map(function (column, index) { return (React.createElement(InfoboxColumn, { key: index, className: clsx(colClass, column.className), label: column.label, value: column.value, icon: column.icon })); }))) : null,
            children)));
}
